import { Box, Button, Menu } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Children, cloneElement, useState } from "react"

export function BasicMenu({
    label = "Menu",
    disabled,
    startIcon,
    endIcon,
    variant = "contained",
    children,
    sx,
    buttonSx,
    buttonDataCy = "basic-menu-button",
    menuDataCy = "basic-menu",
}) {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const items = Children.map(children, (child) => {
        if (!child) return null
        return cloneElement(child, {
            onClick: handleMenuItemClick(child),
        })
    })

    return (
        <Box sx={{ ...sx }}>
            <Button
                disabled={disabled}
                data-cy={buttonDataCy}
                variant={variant}
                onClick={handleClick}
                startIcon={startIcon ? <Iconify icon={startIcon} /> : undefined}
                endIcon={endIcon ? <Iconify icon={endIcon} /> : undefined}
                sx={buttonSx}
            >
                {label}
            </Button>
            <Menu data-cy={menuDataCy} anchorEl={anchorEl} open={open} onClose={handleClose}>
                {items}
            </Menu>
        </Box>
    )

    function handleClick(event) {
        setAnchorEl(event.currentTarget)
    }

    function handleClose() {
        setAnchorEl(null)
    }

    function handleMenuItemClick(child) {
        return (event) => {
            if (child.props.onClick) {
                child.props.onClick(event)
            }
            handleClose()
        }
    }
}
